package fyi.moko.hotpl.ui.detail

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.animateColorAsState
import androidx.compose.animation.animateContentSize
import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.spring
import androidx.compose.animation.core.tween
import androidx.compose.animation.expandVertically
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.shrinkVertically
import androidx.compose.animation.slideInVertically
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.Image
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.background
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.Check
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.Favorite
import androidx.compose.material.icons.filled.FavoriteBorder
import androidx.compose.material.icons.filled.Person
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExtendedFloatingActionButton
import androidx.compose.material3.FilterChip
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.ModalBottomSheet
import androidx.compose.material3.rememberModalBottomSheetState
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Switch
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.TopAppBar
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.ui.graphics.Color
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.produceState
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.drawWithContent
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.layout.layout
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.semantics.clearAndSetSemantics
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.selected
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.lerp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import fyi.moko.hotpl.ui.components.PhotoLoad
import fyi.moko.hotpl.ui.components.StoredPhotoTile
import fyi.moko.hotpl.ui.components.rememberStoredPhoto
import fyi.moko.hotpl.domain.model.Emotion
import fyi.moko.hotpl.domain.model.Place
import fyi.moko.hotpl.domain.model.PlaceCategory
import fyi.moko.hotpl.domain.model.PlaceRichness
import fyi.moko.hotpl.domain.model.PlaceStatus
import fyi.moko.hotpl.domain.model.PhotoGroup
import fyi.moko.hotpl.domain.model.PhotoRef
import fyi.moko.hotpl.domain.model.RichnessSignal
import fyi.moko.hotpl.domain.model.Visibility
import fyi.moko.hotpl.domain.model.sharedPhotoFileNames
import fyi.moko.hotpl.domain.model.displayLabel
import fyi.moko.hotpl.ui.photo.PhotoAction
import fyi.moko.hotpl.ui.photo.PhotoActionSheet
import fyi.moko.hotpl.ui.placeform.PickedImage
import fyi.moko.hotpl.ui.placeform.decodeImageBitmap
import fyi.moko.hotpl.ui.placeform.rememberImageCapturer
import fyi.moko.hotpl.ui.placeform.rememberMultiImagePicker
import fyi.moko.hotpl.domain.model.Visit
import fyi.moko.hotpl.ui.isIosPlatform
import fyi.moko.hotpl.ui.friends.mutualWishCaption
import fyi.moko.hotpl.ui.share.buildSharePlaceText
import fyi.moko.hotpl.ui.share.rememberShareTextLauncher
import fyi.moko.hotpl.ui.theme.WarmthBar
import fyi.moko.hotpl.ui.theme.dotColor
import fyi.moko.hotpl.ui.theme.stackedPaper
import fyi.moko.hotpl.ui.util.formatDate
import kotlinx.coroutines.launch
import org.koin.compose.koinInject
import org.koin.compose.viewmodel.koinViewModel

@OptIn(ExperimentalMaterial3Api::class, ExperimentalLayoutApi::class)
@Composable
fun DetailScreen(
    placeId: String,
    onBack: () -> Unit,
    onEdit: () -> Unit,
    onDeleted: () -> Unit,
    /** Opens the full-screen viewer. [visitId] non-null means "page this visit's photos". */
    onOpenPhoto: (fileName: String, visitId: String?) -> Unit,
) {
    val viewModel: DetailViewModel = koinViewModel()
    LaunchedEffect(placeId) { viewModel.setPlaceId(placeId) }
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    val emotionLabels by viewModel.emotionLabels.collectAsStateWithLifecycle()
    val friendWishNames by viewModel.friendWishNames.collectAsStateWithLifecycle()
    val scope = rememberCoroutineScope()
    val snackbarHostState = remember { SnackbarHostState() }
    val showMessage: (String) -> Unit = { msg -> scope.launch { snackbarHostState.showSnackbar(msg) } }
    val openInMaps = rememberOpenInMapsLauncher()
    val uriHandler = LocalUriHandler.current
    val shareText = rememberShareTextLauncher()
    var showDeleteDialog by remember { mutableStateOf(false) }
    var showShareChoice by remember { mutableStateOf(false) }
    var showRichnessSheet by remember { mutableStateOf(false) }

    // 저장이 실패하면 방문 기록 다이얼로그가 열린 채로 남는다. 스낵바가 없으면 "저장을 눌렀는데
    // 아무 일도 안 일어난다"로 보인다 — 웹에서 저장 공간이 찼을 때 실제로 그 상태가 된다.
    viewModel.saveError?.let { message ->
        LaunchedEffect(message) {
            snackbarHostState.showSnackbar(message)
            viewModel.dismissSaveError()
        }
    }

    // The cover photo is resolved here, above the header, because the whole screen keys
    // off whether a photo is actually on screen — not off whether a file name is set.
    // 다른 기기에서 내려온 장소는 파일명만 먼저 오고 바이트는 뒤따라 내려온다. 파일명만
    // 보고 사진 레이아웃(검은 스크림·흰 제목·상단바 제목 숨김)을 켜면 회색 일러스트 위에
    // 그것들이 얹힌다. 헤더는 여러 장을 넘겨 보지만 레이아웃을 정하는 건 첫 장(대표)이다.
    val headerPhoto = rememberStoredPhoto(state.place?.let { headerPhotoOrder(it).firstOrNull() }).photo
    val richness = when (headerPhoto) {
        // Fetching draws as "no photo" too: a download can take seconds, and a scrim over
        // the illustration for that long is the bug this exists to prevent.
        PhotoLoad.Unavailable, PhotoLoad.Lost, PhotoLoad.Fetching -> state.richness.without(RichnessSignal.PHOTO)
        // Loading keeps the calculator's answer so a place that does have its photo
        // doesn't shrink and re-grow on every open.
        PhotoLoad.Loading, is PhotoLoad.Loaded -> state.richness
    }

    // Hoisted so the top bar can hand its title off to the header's overlaid one.
    val scrollState = rememberScrollState()
    val titleOnHeader = RichnessSignal.PHOTO in richness
    val density = LocalDensity.current
    val handoffStartPx = with(density) { TITLE_HANDOFF_START.toPx() }
    val handoffSpanPx = with(density) { (TITLE_HANDOFF_END - TITLE_HANDOFF_START).toPx() }
    // 0f = 헤더가 제목을 들고 있음, 1f = 상단바가 되찾음.
    val handoff: () -> Float = {
        if (titleOnHeader) {
            ((scrollState.value - handoffStartPx) / handoffSpanPx).coerceIn(0f, 1f)
        } else {
            1f
        }
    }

    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        topBar = {
            TopAppBar(
                title = {
                    Text(
                        text = state.place?.name ?: "Place",
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        // 사진이 있으면 이름이 헤더 위에 크게 올라가므로 상단바 제목은
                        // 숨겼다가, 헤더가 스크롤로 밀려 올라간 만큼 되찾는다. 스크롤 값
                        // 읽기는 graphicsLayer 안에서 — 프레임마다 recomposition을
                        // 일으키지 않고 레이어만 무효화된다.
                        modifier = Modifier.graphicsLayer { alpha = handoff() },
                    )
                },
                navigationIcon = {
                    TextButton(onClick = onBack) { Text("Back") }
                },
                actions = {
                    if (state.place != null) {
                        TextButton(onClick = onEdit) { Text("Edit") }
                        // iOS: "log visit" as a nav-bar + (top right) per HIG; Android
                        // keeps the Material FAB (see floatingActionButton). Delete moved
                        // out of the bar to a destructive button at the bottom of the page.
                        if (isIosPlatform) {
                            IconButton(
                                onClick = viewModel::openLogVisitDialog,
                                modifier = Modifier.testTag("detail-log-visit"),
                            ) {
                                Icon(Icons.Default.Add, contentDescription = "Log visit")
                            }
                        }
                    }
                },
            )
        },
        floatingActionButton = {
            if (!isIosPlatform && state.place != null) {
                ExtendedFloatingActionButton(onClick = viewModel::openLogVisitDialog) {
                    Text("Log visit")
                }
            }
        },
    ) { innerPadding ->
        val place = state.place
        when {
            place != null -> {
                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(innerPadding)
                        .verticalScroll(scrollState)
                        .padding(16.dp),
                    verticalArrangement = Arrangement.spacedBy(16.dp),
                ) {
                    // The map is intentionally gone from the header — the location is still one
                    // tap away via "Open in Maps" below. The frame grows with richness; inside
                    // it the photos page.
                    DetailHeader(
                        place = place,
                        richness = richness,
                        onPhotoClick = { fileName -> onOpenPhoto(fileName, null) },
                        onMeterClick = { showRichnessSheet = true },
                        handoff = handoff,
                        modifier = Modifier.testTag("detail-header-pager"),
                    )
                    // 헤더는 대표 사진부터 넘겨 보는 자리이고, 가게에 쌓인 사진은 여기서 전부 보여준다.
                    // 대표와 겹쳐도 상관없다 — 헤더는 "이 가게" 식별용, 갤러리는 "가게의 모습" 전체.
                    if (place.photos.isNotEmpty()) {
                        PlacePhotoGallery(
                            photos = place.photos,
                            onPhotoClick = { fileName -> onOpenPhoto(fileName, null) },
                        )
                    }
                    // 리뷰어가 이 페이지를 다시 여는 이유는 "그때 뭘 먹었더라, 또 먹으러 갈까"다.
                    // 음식 사진은 여전히 그날 방문의 것이지만(분류는 그대로), 답을 얻으려고 방문
                    // 이력까지 스크롤해 내려가야 했던 것을 여기로 끌어올린다.
                    val ate = remember(state.visits) { whatYouAtePhotos(state.visits) }
                    if (ate.isNotEmpty()) {
                        WhatYouAteStrip(
                            photos = ate,
                            onPhotoClick = { visitId, fileName ->
                                onOpenPhoto(fileName, visitId)
                            },
                        )
                    }
                    // With a photo the meter rides the header's bottom scrim instead —
                    // showing it twice would undo the point of moving it up there.
                    if (RichnessSignal.PHOTO !in richness) {
                        RichnessMeter(richness, onClick = { showRichnessSheet = true })
                    }
                    // Revisit intent requires a recorded visit. The visit check also protects
                    // legacy "to try" records whose status defaulted to VISITED.
                    if (place.status == PlaceStatus.VISITED && state.visits.isNotEmpty()) {
                        LikedRow(
                            liked = place.liked,
                            onToggle = viewModel::toggleLiked,
                        )
                    }
                    // Boxed "who sees this" card (Stitch luna_bakery_detail_compact
                    // mockup, docs/design-ref) — same FilterChip selection mechanics,
                    // just grouped so the caption reads as belonging to the control.
                    Card(
                        shape = RoundedCornerShape(12.dp),
                        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceContainerLow),
                        elevation = CardDefaults.cardElevation(defaultElevation = 0.dp),
                    ) {
                        Column(
                            modifier = Modifier.padding(12.dp),
                            verticalArrangement = Arrangement.spacedBy(8.dp),
                        ) {
                            FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                                Visibility.entries.forEach { option ->
                                    FilterChip(
                                        selected = place.visibility == option,
                                        onClick = { viewModel.setVisibility(option) },
                                        label = { Text(visibilityLabel(option)) },
                                    )
                                }
                            }
                            if (place.visibility != Visibility.PRIVATE) {
                                Text(
                                    text = sharedWithFriendsCaption(place, state.visits),
                                    style = MaterialTheme.typography.labelSmall,
                                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                                )
                            }
                            // 0-37 stage 2: a friend shares this as Want to go and so do I.
                            // Lives in the "who sees this" card because it is the one social
                            // fact about the place; network-fed, so it is simply absent offline.
                            if (friendWishNames.isNotEmpty()) {
                                Row(
                                    verticalAlignment = Alignment.CenterVertically,
                                    horizontalArrangement = Arrangement.spacedBy(6.dp),
                                    modifier = Modifier.testTag("detail-friend-wish"),
                                ) {
                                    Icon(
                                        Icons.Default.Person,
                                        contentDescription = null,
                                        tint = MaterialTheme.colorScheme.tertiary,
                                        modifier = Modifier.size(16.dp),
                                    )
                                    Text(
                                        text = mutualWishCaption(friendWishNames),
                                        style = MaterialTheme.typography.bodyMedium,
                                        color = MaterialTheme.colorScheme.tertiary,
                                    )
                                }
                            }
                        }
                    }
                    // Tags and the note fade/expand in rather than snapping, so returning from
                    // Edit with a newly added tag reads as the screen growing around the change.
                    AnimatedVisibility(
                        visible = place.tags.isNotEmpty(),
                        enter = fadeIn() + expandVertically(),
                        exit = fadeOut() + shrinkVertically(),
                    ) {
                        FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                            place.tags.forEach { tag ->
                                StaticTagChip(tag)
                            }
                        }
                    }
                    val note = place.note
                    AnimatedVisibility(
                        visible = !note.isNullOrBlank(),
                        enter = fadeIn() + expandVertically(),
                        exit = fadeOut() + shrinkVertically(),
                    ) {
                        Text(note.orEmpty(), style = MaterialTheme.typography.bodyLarge)
                    }
                    val locationContext = place.locationContext
                    val phoneNumber = place.phoneNumber
                    val website = place.website
                    val latitude = place.latitude
                    val longitude = place.longitude
                    val hasContactInfo = !locationContext.isNullOrBlank() ||
                        !phoneNumber.isNullOrBlank() ||
                        !website.isNullOrBlank() ||
                        (latitude != null && longitude != null)
                    // Grouped into one card (Stitch mockup) so location/contact/action
                    // reads as one unit instead of a loose stack of independently
                    // optional lines — same fields, same conditionals as before.
                    if (hasContactInfo) {
                        Card(
                            shape = RoundedCornerShape(12.dp),
                            colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceContainerLow),
                            elevation = CardDefaults.cardElevation(defaultElevation = 0.dp),
                        ) {
                            Column(
                                modifier = Modifier.padding(12.dp),
                                verticalArrangement = Arrangement.spacedBy(6.dp),
                            ) {
                                if (!locationContext.isNullOrBlank()) {
                                    Text(
                                        text = locationContext,
                                        style = MaterialTheme.typography.bodyMedium,
                                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                                    )
                                }
                                // Only present when sourced from a Directory (Google Places)
                                // import — hidden entirely rather than shown blank otherwise.
                                if (!phoneNumber.isNullOrBlank()) {
                                    Text(
                                        text = phoneNumber,
                                        style = MaterialTheme.typography.bodyMedium,
                                        color = MaterialTheme.colorScheme.primary,
                                        modifier = Modifier.clickable { uriHandler.openUri("tel:$phoneNumber") },
                                    )
                                }
                                if (!website.isNullOrBlank()) {
                                    Text(
                                        text = website,
                                        style = MaterialTheme.typography.bodyMedium,
                                        color = MaterialTheme.colorScheme.primary,
                                        modifier = Modifier.clickable { uriHandler.openUri(website) },
                                    )
                                }
                                // Both actions only make sense with a location: "Open in Maps"
                                // needs coordinates, and Share always includes a map link (a
                                // name-only share isn't useful). Gated on having coordinates.
                                if (latitude != null && longitude != null) {
                                    Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                        TextButton(
                                            onClick = {
                                                if (!openInMaps(latitude, longitude, place.name)) {
                                                    showMessage("No maps app available")
                                                }
                                            },
                                        ) {
                                            Text("Open in Maps")
                                        }
                                        TextButton(
                                            onClick = { showShareChoice = true },
                                        ) {
                                            Text("Share")
                                        }
                                    }
                                }
                            }
                        }
                    }

                    state.lastVisitedAt?.let { lastVisitedAt ->
                        RevisitRhythmCard(lastVisitedAt = lastVisitedAt, visitCount = state.visitCount)
                    }

                    HorizontalDivider()

                    Text(
                        text = "VISIT HISTORY",
                        style = MaterialTheme.typography.labelMedium,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                    if (state.visits.isEmpty()) {
                        Text(
                            text = "Log a visit and it starts building here.",
                            style = MaterialTheme.typography.bodyMedium,
                            color = MaterialTheme.colorScheme.onSurfaceVariant,
                        )
                    } else {
                        VisitTimeline(
                            visits = state.visits,
                            emotionLabels = emotionLabels,
                            onPhotoClick = { visitId, fileName ->
                                onOpenPhoto(fileName, visitId)
                            },
                            // Adding a visit prepends to the list; growing the column instead of
                            // jumping keeps the new entry readable as "one more on the pile".
                            modifier = Modifier.animateContentSize(),
                        )
                    }

                    HorizontalDivider()
                    TextButton(
                        onClick = { showDeleteDialog = true },
                        modifier = Modifier
                            .fillMaxWidth()
                            .testTag("detail-delete"),
                    ) {
                        Text("Delete place", color = MaterialTheme.colorScheme.error)
                    }
                    // Clear the floating "Log visit" FAB on Android so it can't cover
                    // the delete button when scrolled to the bottom.
                    if (!isIosPlatform) {
                        Spacer(Modifier.height(72.dp))
                    }
                }
            }

            state.loading -> {
                Box(
                    Modifier.fillMaxSize().padding(innerPadding),
                    contentAlignment = Alignment.Center,
                ) { CircularProgressIndicator() }
            }

            else -> {
                Box(
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(innerPadding)
                        .padding(24.dp),
                    contentAlignment = Alignment.Center,
                ) {
                    Column(
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.spacedBy(8.dp),
                    ) {
                        Text(
                            text = "This place is no longer available",
                            style = MaterialTheme.typography.titleMedium,
                        )
                        Text(
                            text = "It may have been deleted from your saved places.",
                            style = MaterialTheme.typography.bodyMedium,
                            color = MaterialTheme.colorScheme.onSurfaceVariant,
                        )
                        TextButton(onClick = onBack) { Text("Back") }
                    }
                }
            }
        }
    }

    if (showDeleteDialog) {
        AlertDialog(
            onDismissRequest = { showDeleteDialog = false },
            title = { Text("Delete place") },
            text = { Text("Delete this place and all its visit history? This can't be undone.") },
            confirmButton = {
                TextButton(onClick = {
                    showDeleteDialog = false
                    viewModel.delete(onDeleted)
                }) { Text("Delete") }
            },
            dismissButton = {
                TextButton(onClick = { showDeleteDialog = false }) { Text("Cancel") }
            },
        )
    }

    if (showShareChoice) {
        val sharePlace = state.place
        if (sharePlace?.latitude != null && sharePlace.longitude != null) {
            AlertDialog(
                onDismissRequest = { showShareChoice = false },
                title = { Text("Share location") },
                text = {
                    Text("Share the exact spot, or just the approximate area (~1 km) to keep a precise address (like home) private?")
                },
                confirmButton = {
                    TextButton(onClick = {
                        showShareChoice = false
                        shareText(
                            buildSharePlaceText(
                                name = sharePlace.name,
                                locationContext = sharePlace.locationContext,
                                latitude = sharePlace.latitude,
                                longitude = sharePlace.longitude,
                                approximate = false,
                            ),
                        )
                    }) { Text("Exact location") }
                },
                dismissButton = {
                    TextButton(onClick = {
                        showShareChoice = false
                        shareText(
                            buildSharePlaceText(
                                name = sharePlace.name,
                                locationContext = sharePlace.locationContext,
                                latitude = sharePlace.latitude,
                                longitude = sharePlace.longitude,
                                approximate = true,
                            ),
                        )
                    }) { Text("Approximate area") }
                },
            )
        } else {
            showShareChoice = false
        }
    }

    if (showRichnessSheet) {
        RichnessSheet(
            richness = richness,
            onDismiss = { showRichnessSheet = false },
            onFill = { signal ->
                showRichnessSheet = false
                when (signal) {
                    RichnessSignal.VISIT, RichnessSignal.STORY -> viewModel.openLogVisitDialog()
                    RichnessSignal.PHOTO, RichnessSignal.TAGS -> onEdit()
                }
            },
        )
    }

    if (viewModel.showLogVisitDialog) {
        val multiPicker = rememberMultiImagePicker()
        val imageCapturer = rememberImageCapturer()
        LogVisitDialog(
            note = viewModel.visitNoteInput,
            onNoteChange = viewModel::onVisitNoteChange,
            selectedEmotion = viewModel.visitEmotionInput,
            onEmotionSelect = viewModel::onVisitEmotionSelect,
            emotionLabels = emotionLabels,
            photos = viewModel.pendingVisitPhotos,
            classifying = viewModel.classifyingPhotos,
            onAddPhotos = { multiPicker.pick(viewModel::onVisitPhotosPicked) },
            // 촬영은 한 장짜리 고르기다 — 축소·분류·목적지 배정이 갤러리 경로와 같다.
            onCapturePhoto = {
                imageCapturer.capture { bytes -> bytes?.let { viewModel.onVisitPhotosPicked(listOf(PickedImage(it))) } }
            },
            cameraAvailable = imageCapturer.isAvailable,
            onPhotoGroupChange = viewModel::onVisitPhotoGroupChange,
            onPhotoClick = viewModel::openPendingPhotoActions,
            revisit = viewModel.visitRevisitInput,
            onRevisitChange = viewModel::onVisitRevisitChange,
            onDismiss = viewModel::dismissLogVisitDialog,
            onSave = viewModel::addVisitNow,
        )
    }

    viewModel.pendingPhotoActionIndex?.let { _ ->
        PhotoActionSheet(
            actions = listOf(
                PhotoAction("Delete this photo", viewModel::removeTargetedPendingPhoto),
            ),
            onDismiss = viewModel::dismissPendingPhotoActions,
        )
    }
}

/**
 * Log-a-visit sheet (Stitch log_a_visit_compact mockup, docs/design-ref) — was an
 * [AlertDialog], now a [ModalBottomSheet] to match the mockup's drag-handle + centered
 * title + "Save" text-action header. photos/classifying/photo callbacks default to
 * empty/no-op so a caller that only cares about the note+emotion can omit them.
 */
@OptIn(ExperimentalLayoutApi::class, ExperimentalMaterial3Api::class)
@Composable
fun LogVisitDialog(
    note: String,
    onNoteChange: (String) -> Unit,
    selectedEmotion: Emotion?,
    onEmotionSelect: (Emotion) -> Unit,
    onDismiss: () -> Unit,
    onSave: () -> Unit,
    photos: List<PendingVisitPhoto> = emptyList(),
    classifying: Boolean = false,
    onAddPhotos: () -> Unit = {},
    onCapturePhoto: () -> Unit = {},
    cameraAvailable: Boolean = false,
    onPhotoGroupChange: (Int, PhotoGroup) -> Unit = { _, _ -> },
    onPhotoClick: (Int) -> Unit = {},
    emotionLabels: Map<String, String> = emptyMap(),
    revisit: Boolean = false,
    onRevisitChange: (Boolean) -> Unit = {},
) {
    ModalBottomSheet(
        onDismissRequest = onDismiss,
        // 부분 확장 상태의 시트는 화면 절반 남짓이라, 펼친 폴더블처럼 키가 큰 화면에서는
        // 노트 입력칸이 그 아래로 밀려난다 — 키보드까지 올라오면 손이 닿지 않는다.
        // (접었을 때만 보이던 이유가 이것이다. 좁은 화면에서는 시트가 화면을 거의 채운다.)
        sheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true),
        // 시트는 자체 창에 그려지고 기본 인셋이 IME를 제외한다 — 그대로 두면 아래의
        // imePadding()이 볼 인셋 자체가 남지 않는다. 인셋을 0으로 넘겨 콘텐츠가
        // 직접 처리하게 한다.
        contentWindowInsets = { WindowInsets(0, 0, 0, 0) },
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                // ── 키보드가 노트 입력칸을 가리던 문제 ──────────────────────────
                // `MainActivity`가 `enableEdgeToEdge()`를 쓰므로 창은 IME에 맞춰
                // 줄어들지 않고, 시트는 자기 창에서 화면 아래에 붙어 있다 — 그래서
                // 시트를 통째로 밀어 올리는 방법(바깥 `imePadding()`)은 통하지 않는다.
                // 실측: 입력칸이 2006 → 1549로만 올라와 여전히 키보드 뒤였다.
                //
                // 시트가 전체 높이를 쓰게 된 뒤에야 이 둘이 제 역할을 한다: imePadding이
                // 보이는 영역을 키보드 위로 줄이고, 그 안에서 스크롤이 포커스된
                // 텍스트필드를 끌어올린다.
                .imePadding()
                .verticalScroll(rememberScrollState())
                .padding(horizontal = 20.dp)
                .padding(bottom = 32.dp),
            verticalArrangement = Arrangement.spacedBy(16.dp),
        ) {
            Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                IconButton(onClick = onDismiss) {
                    Icon(Icons.Default.Close, contentDescription = "Close")
                }
                Text(
                    text = "Log a Visit",
                    style = MaterialTheme.typography.headlineMedium,
                    textAlign = TextAlign.Center,
                    modifier = Modifier.weight(1f),
                )
                TextButton(onClick = onSave) {
                    Text("Save", style = MaterialTheme.typography.labelLarge, color = MaterialTheme.colorScheme.primary)
                }
            }

            LogVisitSectionLabel("HOW DID IT FEEL?")
            // Optional, single-select mood tag — a quiet color/word, not a form field
            // (PROJECT.md §4-⑥). Tapping the selected chip again clears it.
            FlowRow(horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                Emotion.entries.forEach { emotion ->
                    EmotionChip(
                        emotion = emotion,
                        label = emotion.displayLabel(emotionLabels),
                        selected = emotion == selectedEmotion,
                        onClick = { onEmotionSelect(emotion) },
                    )
                }
            }

            VisitPhotoSection(
                photos = photos,
                classifying = classifying,
                onAddPhotos = onAddPhotos,
                onCapturePhoto = onCapturePhoto,
                cameraAvailable = cameraAvailable,
                onPhotoGroupChange = onPhotoGroupChange,
                onPhotoClick = onPhotoClick,
            )

            LogVisitSectionLabel("JOURNAL ENTRY")
            OutlinedTextField(
                value = note,
                onValueChange = onNoteChange,
                modifier = Modifier.fillMaxWidth(),
                placeholder = { Text("Optional note") },
                textStyle = MaterialTheme.typography.bodyLarge,
                singleLine = false,
                minLines = 3,
                maxLines = 5,
                colors = OutlinedTextFieldDefaults.colors(
                    unfocusedContainerColor = MaterialTheme.colorScheme.surfaceContainerLow,
                    focusedContainerColor = MaterialTheme.colorScheme.surfaceContainerLow,
                    focusedBorderColor = MaterialTheme.colorScheme.tertiary,
                ),
            )

            // 다시 가고 싶은지는 가 본 직후가 가장 또렷하다 — Edit 폼의 스위치를 걷어내고 여기로
            // 옮겼다(2026-09-17). 상세의 하트(LikedRow)와 같은 값을 움직인다.
            LogVisitSectionLabel("WOULD YOU COME BACK?")
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clickable { onRevisitChange(!revisit) },
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(8.dp),
            ) {
                Icon(
                    if (revisit) Icons.Default.Favorite else Icons.Default.FavoriteBorder,
                    contentDescription = null,
                    tint = if (revisit) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.onSurfaceVariant,
                )
                Text(
                    text = if (revisit) "Yes, revisit soon" else "Not sure yet",
                    style = MaterialTheme.typography.bodyMedium,
                    modifier = Modifier.weight(1f),
                )
                Switch(checked = revisit, onCheckedChange = onRevisitChange)
            }
        }
    }
}

@Composable
private fun LogVisitSectionLabel(text: String) {
    Text(text = text, style = MaterialTheme.typography.labelMedium, color = MaterialTheme.colorScheme.onSurfaceVariant)
}

@Composable
private fun EmotionChip(
    emotion: Emotion,
    label: String,
    selected: Boolean,
    onClick: () -> Unit,
) {
    val shape = if (isIosPlatform) RoundedCornerShape(percent = 50) else RoundedCornerShape(14.dp)
    val borderColor = if (selected) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.outlineVariant
    Row(
        modifier = Modifier
            .clip(shape)
            .border(BorderStroke(if (selected) 2.dp else 1.dp, borderColor), shape)
            .semantics { this.selected = selected }
            .clickable(
                role = Role.Button,
                onClickLabel = if (selected) "Remove $label tag" else "Tag as $label",
                onClick = onClick,
            )
            .padding(horizontal = 10.dp, vertical = 6.dp)
            .testTag("log-visit-emotion-${emotion.id}"),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(6.dp),
    ) {
        Box(
            modifier = Modifier
                .size(10.dp)
                .clip(CircleShape)
                .background(emotion.dotColor),
        )
        Text(text = label, style = MaterialTheme.typography.labelSmall)
    }
}

private val HEADER_HEIGHT_BARE = 170.dp
private val HEADER_HEIGHT_FULL = 290.dp
private val HEADER_CORNER_BARE = 16.dp

/** Must match the content Column's horizontal padding — that's exactly what we reclaim. */
private val HEADER_MAX_BLEED = 16.dp

/** One-shot light sweep across the header when the last richness signal lands. */
private const val COMPLETION_SWEEP_MS = 780

// Scroll window over which the title crosses from the header back to the top bar. Starts
// late on purpose: the handoff should finish just as the header's own title slides under
// the bar, so the two names are never both fully readable.
private val TITLE_HANDOFF_START = 150.dp
private val TITLE_HANDOFF_END = 240.dp

/** Ceiling for the header's warm tint at full richness — a tone shift, never a wash. */
private const val HEADER_MAX_WARMTH = 0.14f

/**
 * The header frame: the image plus everything that reacts to how filled-in the place is.
 *
 * ── 왜 헤더 하나에 몰아넣었나 ──────────────────────────────
 *  · 상세 화면은 텍스트 줄의 나열이라, 값이 늘어도 "줄이 하나 더 생겼다" 이상으로
 *    읽히지 않는다. 그래서 변화를 여러 곳에 조금씩 뿌리는 대신 헤더 한 곳에서
 *    크게 일으킨다 — 높이, 화면 폭까지의 확장, 모서리, 온도가 같은 값
 *    ([PlaceRichness.fraction]) 하나로 함께 움직인다.
 *  · 다 채운 장소는 헤더가 화면 끝까지 닿고 모서리가 사라진다. 비어 있는 장소는
 *    여백 안에 얌전히 든 둥근 카드로 남는다. 둘을 나란히 놓으면 다른 화면처럼 보인다.
 *  · 온기(warm tint)는 사진이 없을 때만 쓴다. 사진 위에 14% 틴트를 얹어봐야 보이지
 *    않고, 사진이 있는 헤더는 아래쪽 그라데이션이 그 역할을 대신한다.
 */
@Composable
private fun DetailHeader(
    place: Place,
    richness: PlaceRichness,
    onPhotoClick: (String) -> Unit,
    onMeterClick: () -> Unit,
    modifier: Modifier = Modifier,
    /** 0f while the header owns the title, 1f once the top bar has taken it back. */
    handoff: () -> Float = { 1f },
) {
    val hasPhoto = RichnessSignal.PHOTO in richness
    val grow by animateFloatAsState(
        targetValue = richness.fraction,
        animationSpec = tween(durationMillis = 520),
        label = "detail-header-grow",
    )
    val warmTone = MaterialTheme.colorScheme.primary

    // 마지막 한 칸이 채워지는 순간에만 한 번 훑고 지나가는 빛. 이미 다 채워진 장소를
    // 열 때는 켜지지 않는다 — 이 컴포저블은 place가 로드된 뒤에야 처음 구성되므로
    // [wasComplete]가 이미 true로 시작한다.
    val complete = richness.filledCount == PlaceRichness.TOTAL_SIGNALS
    var wasComplete by remember { mutableStateOf(complete) }
    val sweep = remember { Animatable(0f) }
    LaunchedEffect(complete) {
        if (complete != wasComplete) {
            wasComplete = complete
            if (complete) {
                sweep.snapTo(0f)
                sweep.animateTo(1f, tween(durationMillis = COMPLETION_SWEEP_MS))
                sweep.snapTo(0f)
            }
        }
    }

    Box(
        modifier = modifier
            .fillMaxWidth()
            .bleedHorizontally(lerp(0.dp, HEADER_MAX_BLEED, grow))
            .height(lerp(HEADER_HEIGHT_BARE, HEADER_HEIGHT_FULL, grow))
            .clip(RoundedCornerShape(lerp(HEADER_CORNER_BARE, 0.dp, grow)))
            .drawWithContent {
                drawContent()
                val progress = sweep.value
                if (progress > 0f) {
                    // A diagonal band of light travelling left→right across the frame.
                    val bandCenter = -size.width * 0.4f + size.width * 1.8f * progress
                    val half = size.width * 0.22f
                    drawRect(
                        brush = Brush.linearGradient(
                            colors = listOf(
                                Color.Transparent,
                                Color.White.copy(alpha = 0.42f),
                                Color.Transparent,
                            ),
                            start = Offset(bandCenter - half, 0f),
                            end = Offset(bandCenter + half, size.height),
                        ),
                    )
                }
            },
    ) {
        DetailHeaderImage(place = place, onPhotoClick = onPhotoClick, modifier = Modifier.fillMaxSize())
        if (hasPhoto) {
            // Bottom scrim so the meter stays legible over any photo. 사진은 통제할 수
            // 없으므로 (밝은 실외 사진 위 흰 글씨가 최악) 아래쪽은 거의 불투명하게 깐다.
            Box(
                Modifier
                    .matchParentSize()
                    .background(
                        Brush.verticalGradient(
                            0.45f to Color.Transparent,
                            0.78f to Color.Black.copy(alpha = 0.45f),
                            1f to Color.Black.copy(alpha = 0.88f),
                        ),
                    ),
            )
        } else {
            Box(Modifier.matchParentSize().background(warmTone.copy(alpha = grow * HEADER_MAX_WARMTH)))
        }
        AnimatedVisibility(
            visible = richness.isRegular,
            enter = fadeIn() + slideInVertically { -it },
            exit = fadeOut(),
            modifier = Modifier
                .align(Alignment.TopStart)
                .padding(horizontal = lerp(12.dp, 16.dp, grow), vertical = 12.dp),
        ) {
            RegularBadge()
        }
        if (hasPhoto) {
            Column(
                modifier = Modifier
                    .align(Alignment.BottomStart)
                    .padding(horizontal = lerp(12.dp, 16.dp, grow), vertical = 14.dp),
                verticalArrangement = Arrangement.spacedBy(6.dp),
            ) {
                Text(
                    text = place.name,
                    style = MaterialTheme.typography.headlineSmall,
                    fontWeight = FontWeight.SemiBold,
                    color = Color.White,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                    // 상단바 제목이 같은 이름을 이미 읽어 준다. 여기서 한 번 더 읽으면
                    // 스크린리더 사용자에겐 같은 말이 두 번 나올 뿐이다.
                    modifier = Modifier
                        .graphicsLayer { alpha = 1f - handoff() }
                        .clearAndSetSemantics { },
                )
                RichnessMeter(richness = richness, onImage = true, onClick = onMeterClick)
            }
        }
    }
}

/**
 * Lets a child reach [amount] past its parent's horizontal padding on each side, without
 * disturbing the parent's layout: the child measures wider, but reports the un-widened
 * width upward and draws itself offset back into the reclaimed margin.
 *
 * 헤더만 화면 폭 끝까지 나가게 하려고 쓴다. 대안은 Column의 padding을 걷어내고
 * 나머지 자식 전부에 horizontal padding을 다시 붙이는 것인데, 그러면 항목을 추가할
 * 때마다 padding을 빠뜨릴 여지가 생긴다.
 */
private fun Modifier.bleedHorizontally(amount: Dp) = this.layout { measurable, constraints ->
    val extra = if (constraints.hasBoundedWidth) (amount.roundToPx() * 2).coerceAtLeast(0) else 0
    val placeable = measurable.measure(
        constraints.copy(
            minWidth = constraints.minWidth + extra,
            maxWidth = constraints.maxWidth + extra,
        ),
    )
    layout(placeable.width - extra, placeable.height) {
        placeable.place(-extra / 2, 0)
    }
}

/**
 * Shown once a place crosses [fyi.moko.hotpl.domain.usecase.REGULAR_VISIT_THRESHOLD] visits.
 * 성취 배지가 아니라 관찰 결과다 — "자주 오는 곳이네"라고 조용히 말할 뿐,
 * 다음 방문을 유도하는 카운터나 진행바는 두지 않는다.
 */
@Composable
private fun RegularBadge() {
    Row(
        modifier = Modifier
            .clip(CircleShape)
            .background(MaterialTheme.colorScheme.primary)
            .padding(horizontal = 12.dp, vertical = 7.dp)
            .testTag("detail-regular-badge"),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(6.dp),
    ) {
        Text(
            text = "Regular spot",
            style = MaterialTheme.typography.labelMedium,
            fontWeight = FontWeight.SemiBold,
            color = MaterialTheme.colorScheme.onPrimary,
        )
    }
}

/**
 * One quiet dot per [RichnessSignal], right under the header so the indicator sits next
 * to the thing it describes. Deliberately unlabeled per dot — it's a texture cue, not a
 * checklist to complete.
 *
 * 점은 신호 순서가 아니라 채워진 개수만큼 왼쪽부터 켠다. 각 점이 어떤 축인지 라벨이
 * 없어서, 신호 순서대로 켜면 "○ ○ ● ●"처럼 뒤에서부터 차오르는 진행바로 오독된다.
 */
@Composable
private fun RichnessMeter(
    richness: PlaceRichness,
    modifier: Modifier = Modifier,
    onImage: Boolean = false,
    /** Opens the checklist behind the dots — the badge itself stays unlabeled (0-25). */
    onClick: () -> Unit = {},
) {
    val accent = if (onImage) Color.White else MaterialTheme.colorScheme.primary
    val labelColor = if (onImage) Color.White else MaterialTheme.colorScheme.onSurface
    // 사진 위에서는 거의 불투명하게 깐다. 반투명 40%로는 사진 무늬가 비쳐서 배지가
    // 배지로 안 읽혔다 (2026-08-05 사용자 확인: "이전과 차이를 모르겠다").
    val containerColor = if (onImage) {
        Color.Black.copy(alpha = 0.78f)
    } else {
        MaterialTheme.colorScheme.surfaceContainerHighest
    }
    val borderColor = if (onImage) {
        Color.White.copy(alpha = 0.65f)
    } else {
        MaterialTheme.colorScheme.primary
    }

    Row(
        modifier = modifier
            .clip(CircleShape)
            .clickable(onClick = onClick)
            .background(containerColor)
            .border(BorderStroke(1.5.dp, borderColor), CircleShape)
            .padding(horizontal = 14.dp, vertical = 9.dp)
            .semantics {
                contentDescription =
                    "${richness.filledCount} of ${PlaceRichness.TOTAL_SIGNALS} kinds of detail added. Tap to see which"
            }
            .testTag("detail-richness-meter"),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(10.dp),
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(6.dp),
        ) {
            repeat(PlaceRichness.TOTAL_SIGNALS) { index ->
                val filled = index < richness.filledCount
                // 빈 칸은 "흐린 점"이 아니라 속이 뚫린 링이다. 흐린 점은 채워진 점과
                // 명도만 다를 뿐이라 작은 크기에서 몇 개가 찼는지 셀 수가 없었다.
                val dotAlpha by animateFloatAsState(
                    targetValue = if (filled) 1f else 0f,
                    animationSpec = tween(durationMillis = 320),
                    label = "richness-dot-fill-$index",
                )
                Box(
                    modifier = Modifier.size(11.dp),
                    contentAlignment = Alignment.Center,
                ) {
                    Box(
                        modifier = Modifier
                            .size(11.dp)
                            .border(1.5.dp, accent.copy(alpha = 0.55f), CircleShape),
                    )
                    Box(
                        modifier = Modifier
                            .size(11.dp)
                            .clip(CircleShape)
                            .background(accent.copy(alpha = dotAlpha)),
                    )
                }
            }
        }
        Text(
            text = richnessLabel(richness.filledCount),
            style = MaterialTheme.typography.labelLarge,
            fontWeight = FontWeight.SemiBold,
            color = labelColor,
        )
    }
}

/**
 * What the dots stand for, one line per axis. A filled line is just a tick; an empty line is
 * a button to the input that fills it. No "3 of 4" score anywhere — the sheet answers
 * "which", the badge already answers "how many".
 */
@OptIn(ExperimentalMaterial3Api::class)
@Composable
private fun RichnessSheet(
    richness: PlaceRichness,
    onDismiss: () -> Unit,
    onFill: (RichnessSignal) -> Unit,
) {
    ModalBottomSheet(onDismissRequest = onDismiss) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 24.dp)
                .padding(bottom = 32.dp)
                .testTag("detail-richness-sheet"),
            verticalArrangement = Arrangement.spacedBy(4.dp),
        ) {
            Text(
                text = "What this place has",
                style = MaterialTheme.typography.titleMedium,
                modifier = Modifier.padding(bottom = 12.dp),
            )
            richnessChecklist(richness).forEach { row ->
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .clip(MaterialTheme.shapes.medium)
                        .then(if (row.filled) Modifier else Modifier.clickable { onFill(row.signal) })
                        .padding(horizontal = 8.dp, vertical = 12.dp),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(14.dp),
                ) {
                    Icon(
                        imageVector = if (row.filled) Icons.Default.Check else Icons.Default.Add,
                        contentDescription = if (row.filled) "Added" else "Missing",
                        tint = if (row.filled) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                    Column {
                        Text(
                            text = row.label,
                            style = MaterialTheme.typography.bodyLarge,
                            color = if (row.filled) MaterialTheme.colorScheme.onSurface else MaterialTheme.colorScheme.onSurfaceVariant,
                        )
                        if (!row.filled) {
                            Text(
                                text = row.hint,
                                style = MaterialTheme.typography.bodySmall,
                                color = MaterialTheme.colorScheme.primary,
                            )
                        }
                    }
                }
            }
        }
    }
}

/**
 * The revisit-intent heart. Toggling it on gives a short pop; toggling it off does not —
 * 되돌리는 동작에 축하 모션을 붙이면 무엇을 권하는 화면인지 흐려진다.
 */
@Composable
private fun LikedRow(
    liked: Boolean,
    onToggle: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val scale = remember { Animatable(1f) }
    var lastLiked by remember { mutableStateOf(liked) }
    LaunchedEffect(liked) {
        if (liked != lastLiked) {
            lastLiked = liked
            if (liked) {
                scale.animateTo(1.3f, tween(durationMillis = 130))
                scale.animateTo(
                    targetValue = 1f,
                    animationSpec = spring(dampingRatio = Spring.DampingRatioMediumBouncy),
                )
            }
        }
    }

    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp),
    ) {
        IconButton(
            onClick = onToggle,
            modifier = Modifier.testTag("detail-toggle-liked"),
        ) {
            Icon(
                if (liked) Icons.Default.Favorite else Icons.Default.FavoriteBorder,
                contentDescription = if (liked) "Revisit soon" else "Mark to revisit",
                tint = if (liked) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.onSurfaceVariant,
                modifier = Modifier.graphicsLayer {
                    scaleX = scale.value
                    scaleY = scale.value
                },
            )
        }
        Text(
            // Heart = revisit intent, not generic "like" (design doc 2026-07-19).
            text = if (liked) "Revisit soon" else "Mark to revisit",
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }
}

/**
 * The header's picture: the place's photos, cover first, paged by swipe; the derived
 * grayscale category illustration when none has arrived. The frame around it
 * ([DetailHeader]) draws the scrim, title and meter, so the dots sit at the top-end where
 * they don't collide with those.
 *
 * ── 못 받은 장은 건너뛴다 ──────────────────────────────
 * 페이지는 파일명이 아니라 **지금 그릴 수 있는 사진**이다. 다른 기기가 아직 안 올린 사진을
 * 페이지로 두면 스크림 아래 일러스트가 한 장씩 끼어들어 "사진이 깨졌나" 싶어진다. 내려오는
 * 순서대로 페이지가 늘어나고, 갤러리가 어차피 같은 파일들을 요청하므로 추가 비용은 없다.
 */
@Composable
private fun DetailHeaderImage(place: Place, onPhotoClick: (String) -> Unit, modifier: Modifier) {
    val order = remember(place.photos, place.imageFileName) { headerPhotoOrder(place) }
    // One resolver per file, keyed so reordering (a new cover) doesn't restart the loads.
    // 파일명을 비트맵과 함께 들고 다닌다 — 탭했을 때 뷰어에 넘길 것이 이름이기 때문이다.
    val loaded = order.mapNotNull { fileName ->
        key(fileName) {
            (rememberStoredPhoto(fileName).photo as? PhotoLoad.Loaded)?.value?.let { fileName to it }
        }
    }
    if (loaded.isEmpty()) {
        PlaceCategoryImage(category = PlaceCategory.fromTags(place.tags), modifier = modifier)
        return
    }

    val pagerState = rememberPagerState(pageCount = { loaded.size })
    Box(modifier) {
        HorizontalPager(state = pagerState, modifier = Modifier.fillMaxSize()) { page ->
            Image(
                bitmap = loaded[page].second,
                contentDescription = place.name,
                contentScale = ContentScale.Crop,
                // 헤더는 잘라 보여주는 자리다. 전체 구도는 탭해서 뷰어에서 본다.
                modifier = Modifier.fillMaxSize().clickable { onPhotoClick(loaded[page].first) },
            )
        }
        // Only worth drawing when there is somewhere to swipe to; a lone dot under a single
        // photo would suggest a gesture that does nothing.
        if (loaded.size > 1) {
            PagerDots(
                count = loaded.size,
                current = pagerState.currentPage,
                modifier = Modifier.align(Alignment.TopEnd).padding(12.dp),
            )
        }
    }
}

/** Which page of the header you are on. Drawn over the photo, so it carries its own scrim. */
@Composable
private fun PagerDots(count: Int, current: Int, modifier: Modifier = Modifier) {
    Row(
        modifier = modifier
            .clip(RoundedCornerShape(50))
            .background(Color.Black.copy(alpha = 0.35f))
            .padding(horizontal = 8.dp, vertical = 5.dp)
            .testTag("detail-header-dots"),
        horizontalArrangement = Arrangement.spacedBy(5.dp),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        repeat(count) { index ->
            Box(
                Modifier
                    .size(6.dp)
                    .clip(CircleShape)
                    .background(Color.White.copy(alpha = if (index == current) 1f else 0.4f)),
            )
        }
    }
}

/**
 * What actually leaves the device for a FRIENDS/PUBLIC place — must track
 * [fyi.moko.hotpl.data.network.PublicPlaceDto] field for field (backlog 0-36).
 */
private fun sharedWithFriendsCaption(place: Place, visits: List<Visit>): String {
    val photos = place.sharedPhotoFileNames(visits).size
    val photoPart = when (photos) {
        0 -> ""
        1 -> ", plus your cover photo"
        else -> ", plus $photos photos (cover and food)"
    }
    return "Friends see the name, tags, status, phone and website$photoPart — not your notes or other photos."
}

private fun visibilityLabel(visibility: Visibility): String = when (visibility) {
    Visibility.PRIVATE -> "Private"
    Visibility.FRIENDS -> "Friends"
    Visibility.PUBLIC -> "Public"
}

/**
 * "Revisit Rhythm" card (Stitch luna_bakery_detail_compact mockup) — surfaces the
 * [state.lastVisitedAt]/[state.visitCount] data already computed by [DetailViewModel]
 * behind a warmth bar instead of plain text. The fill fraction is a purely
 * presentational read of visit count (caps out visually at 5 visits); it doesn't call
 * into [fyi.moko.hotpl.domain.usecase.RevisitWindowCalculator] — that use case answers
 * a different question (is now a good window to go back) than this card does (how much
 * of a habit this place has become).
 */
@Composable
private fun RevisitRhythmCard(lastVisitedAt: Long, visitCount: Int) {
    Card(
        shape = RoundedCornerShape(12.dp),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceContainer),
        elevation = CardDefaults.cardElevation(defaultElevation = 0.dp),
    ) {
        Column(modifier = Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            Text(
                text = "REVISIT RHYTHM",
                style = MaterialTheme.typography.labelMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            Text(
                text = "Last visited ${formatDate(lastVisitedAt)}",
                style = MaterialTheme.typography.headlineMedium,
            )
            WarmthBar(fraction = (visitCount / 5f).coerceIn(0f, 1f))
            Text(
                text = detailVisitCountLabel(visitCount),
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
    }
}

/** Read-only tag display. Detail screen has no list to filter, so this is not clickable (unlike the home screen's tag chips). */
@Composable
private fun StaticTagChip(tag: String) {
    val shape = RoundedCornerShape(percent = 50)
    Box(
        modifier = Modifier
            .clip(shape)
            .background(MaterialTheme.colorScheme.surfaceContainerLowest)
            .border(BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant), shape)
            .padding(horizontal = 12.dp, vertical = 6.dp),
    ) {
        Text(
            text = tag,
            style = MaterialTheme.typography.labelMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }
}

/**
 * A vertical journal-style timeline of visits to a place.
 *
 * The list is rendered in the order it is received (current repository emits newest
 * first), so the chronologically first visit is the last item and is labeled
 * "First visit".
 */
@Composable
fun VisitTimeline(
    visits: List<Visit>,
    onPhotoClick: (visitId: String, fileName: String) -> Unit = { _, _ -> },
    modifier: Modifier = Modifier,
    emotionLabels: Map<String, String> = emptyMap(),
) {
    Column(modifier = modifier.fillMaxWidth()) {
        visits.forEachIndexed { index, visit ->
            TimelineItem(
                visit = visit,
                emotionLabels = emotionLabels,
                isFirst = index == 0,
                isLast = index == visits.lastIndex,
                isFirstVisit = index == visits.lastIndex,
                onPhotoClick = onPhotoClick,
            )
        }
    }
}

@Composable
private fun TimelineItem(
    visit: Visit,
    emotionLabels: Map<String, String>,
    isFirst: Boolean,
    isLast: Boolean,
    isFirstVisit: Boolean,
    onPhotoClick: (visitId: String, fileName: String) -> Unit,
    modifier: Modifier = Modifier,
) {
    val emotion = Emotion.fromId(visit.emotion)
    val nodeColor = emotion?.dotColor ?: MaterialTheme.colorScheme.outlineVariant
    val lineColor = MaterialTheme.colorScheme.surfaceVariant

    Row(
        modifier = modifier
            .fillMaxWidth()
            .height(IntrinsicSize.Min),
    ) {
        // Left rail: vertical line + emotion node, height locked to the right card.
        Box(
            modifier = Modifier
                .width(48.dp)
                .fillMaxHeight(),
            contentAlignment = Alignment.TopCenter,
        ) {
            Canvas(modifier = Modifier.fillMaxSize()) {
                val centerX = size.width / 2f
                val centerY = size.height / 2f

                val startY = if (isFirst) centerY else 0f
                val endY = if (isLast) centerY else size.height
                drawLine(
                    color = lineColor,
                    start = Offset(centerX, startY),
                    end = Offset(centerX, endY),
                    strokeWidth = 2.dp.toPx(),
                )

                drawCircle(
                    color = nodeColor,
                    radius = 6.dp.toPx(),
                    center = Offset(centerX, centerY),
                )
            }
        }

        // Right card: date, visit ordinal, emotion label, note. The most recent entry
        // gets the mockups' recurring "second sheet of paper" depth cue.
        Card(
            modifier = Modifier
                .weight(1f)
                .padding(end = 16.dp, bottom = 16.dp)
                .let { if (isFirst) it.stackedPaper() else it },
            shape = RoundedCornerShape(12.dp),
            colors = CardDefaults.cardColors(
                containerColor = MaterialTheme.colorScheme.surfaceContainerLowest,
            ),
            border = BorderStroke(
                width = 1.dp,
                color = MaterialTheme.colorScheme.outlineVariant.copy(alpha = 0.5f),
            ),
        ) {
            Column(modifier = Modifier.padding(12.dp)) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Text(
                        text = formatDate(visit.visitedAt),
                        style = MaterialTheme.typography.labelMedium,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                    Text(
                        text = if (isFirstVisit) "First visit" else "Return visit",
                        style = MaterialTheme.typography.labelSmall,
                        color = if (isFirstVisit) {
                            MaterialTheme.colorScheme.primary
                        } else {
                            MaterialTheme.colorScheme.onSurfaceVariant
                        },
                    )
                }

                emotion?.let {
                    Spacer(Modifier.height(4.dp))
                    Text(
                        text = emotion.displayLabel(emotionLabels),
                        style = MaterialTheme.typography.labelSmall,
                        color = nodeColor,
                        modifier = Modifier
                            .clip(RoundedCornerShape(percent = 50))
                            .background(nodeColor.copy(alpha = 0.12f))
                            .padding(horizontal = 10.dp, vertical = 4.dp),
                    )
                }

                val note = visit.note
                if (!note.isNullOrBlank()) {
                    Spacer(Modifier.height(8.dp))
                    Text(
                        text = note,
                        style = MaterialTheme.typography.bodyMedium,
                        fontStyle = FontStyle.Italic,
                        color = MaterialTheme.colorScheme.onSurface,
                    )
                }

                if (visit.photos.isNotEmpty()) {
                    Spacer(Modifier.height(8.dp))
                    Row(
                        modifier = Modifier.fillMaxWidth().horizontalScroll(rememberScrollState()),
                        horizontalArrangement = Arrangement.spacedBy(6.dp),
                    ) {
                        visit.photos.forEach { photo ->
                            StoredPhotoThumbnail(
                                fileName = photo.fileName,
                                size = 56.dp,
                                onClick = { onPhotoClick(visit.id, photo.fileName) },
                            )
                        }
                    }
                }
            }
        }
    }
}

/**
 * 가게에 쌓인 사진들 — 간판·내부·메뉴판처럼 방문이 지나도 남는 것들만 여기 있다.
 * 그날 먹은 것과 사람은 [Visit.photos]로 각 방문 카드에 붙는다.
 */
@Composable
private fun PlacePhotoGallery(
    photos: List<PhotoRef>,
    onPhotoClick: (fileName: String) -> Unit,
    modifier: Modifier = Modifier,
) {
    Column(modifier = modifier, verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Text(
            text = "GALLERY",
            style = MaterialTheme.typography.labelMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Row(
            modifier = Modifier.fillMaxWidth().horizontalScroll(rememberScrollState()),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            photos.forEach { photo ->
                StoredPhotoThumbnail(
                    fileName = photo.fileName,
                    size = 96.dp,
                    onClick = { onPhotoClick(photo.fileName) },
                )
            }
        }
    }
}

/**
 * 이 가게에서 먹은 것들 — 최근 방문부터, 각 사진 아래에 그날 날짜.
 *
 * 날짜를 다는 게 핵심이다. 음식 사진 자체는 "맛있어 보인다"까지만 말하지만, 날짜가 붙으면
 * "여름에 먹었던 그거"가 되어 다시 갈지 판단할 수 있는 기억이 된다.
 */
@Composable
private fun WhatYouAteStrip(
    photos: List<DatedVisitPhoto>,
    onPhotoClick: (visitId: String, fileName: String) -> Unit,
    modifier: Modifier = Modifier,
) {
    Column(modifier = modifier, verticalArrangement = Arrangement.spacedBy(8.dp)) {
        Text(
            text = "WHAT YOU ATE",
            style = MaterialTheme.typography.labelMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Row(
            modifier = Modifier.fillMaxWidth().horizontalScroll(rememberScrollState()),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            photos.forEach { photo ->
                Column(
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(4.dp),
                ) {
                    StoredPhotoThumbnail(
                        fileName = photo.fileName,
                        size = 96.dp,
                        onClick = { onPhotoClick(photo.visitId, photo.fileName) },
                    )
                    Text(
                        text = formatDate(photo.visitedAt),
                        style = MaterialTheme.typography.labelSmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                }
            }
        }
    }
}

/**
 * 파일명으로 그리는 정사각 썸네일. 로컬에 없으면 계정 사진 저장소에서 받아오며, 그동안은
 * 스피너, 끝내 없으면 새로고침 글리프(탭하면 재시도)를 보인다 — [StoredPhotoTile] 참고.
 */
@Composable
private fun StoredPhotoThumbnail(fileName: String, size: androidx.compose.ui.unit.Dp, onClick: () -> Unit) {
    StoredPhotoTile(handle = rememberStoredPhoto(fileName), size = size, onClick = onClick)
}

private fun detailVisitCountLabel(count: Int): String = if (count == 1) "1 visit" else "$count visits"

/*
 * ── 진입 스태거를 두지 않는 이유 (2026-08-05 검증) ──────────────────────────────
 *  · 블록마다 지연을 줘서 위에서부터 차례로 올라오게 해봤으나, 화면에서는 아무 일도
 *    일어나지 않는 것처럼 보였다. 단계당 400ms로 늘려 확인한 결과 동작 자체는
 *    정상이었고, 문제는 타이밍이었다 — 스태거 전체(~0.5초)가 네비게이션 전환
 *    애니메이션이 끝나기 전에 완료돼서, 화면이 다 보일 땐 이미 끝나 있었다.
 *  · 보이게 하려면 전환보다 오래 끌어야 하는데, 자주 여는 화면이 매번 1초씩
 *    정착하는 건 폴리시가 아니라 지연으로 읽힌다.
 *  · 더 근본적으로, 이 화면의 연출은 "무엇이 바뀌었는가"에 반응해야 한다
 *    (헤더 성장·리치니스 점·완성 스윕·하트 팝). 스태거는 무엇을 바꿨든 열 때마다
 *    똑같이 재생되므로 그 목적과 무관하다. 화면 전환이 이미 등장 연출을 맡고 있다.
 */

/**
 * Phrasing for the richness meter. Observational, not congratulatory — the last step is
 * "Complete", not a reward, because a place with no photo is a perfectly fine place.
 */
private fun richnessLabel(filledCount: Int): String = when (filledCount) {
    0 -> "Just saved"
    1 -> "Getting started"
    2 -> "Filling in"
    3 -> "Well kept"
    else -> "Complete"
}
